import React from 'react'

/* Form & Form Validation */
import * as Yup from 'yup'

import { Form, Input, Select, DatePicker } from 'formik-antd'

import ModalForm from '../../../../core/components/form/modalForm'
import { isNotValid, translateSymfonyErrorToFormik } from '../../../../core/utils/form'

import Moment from 'moment'

const ValidationSchema = Yup.object().shape({
  lqa_type: Yup.string().required('Cannot be blank.'),
  score: Yup.string().required('Cannot be blank.')
})

const _filter = (input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0

const Formulario = (props) => {
  const { onCancel, submitQa, qa, vendors } = props
  const editing = qa?.id > 0

  function handleSubmit (values, bag) {
    const date = values.date == null ? null : Moment(values.date).format('YYYY-MM-DD')

    let form = new FormData()

    if (editing) {
      form = { qaId: qa.id, lqa_type: values.lqa_type, score: values.score, date: date }
    } else {
      if (values.file) {
        form.append('file', values.file)
      }

      values.vendors.forEach(function (element) {
        form.append('vendors[]', element)
      })

      form.append('lqa_type', values.lqa_type)
      form.append('score', values.score)
      form.append('date', date)

      if (values.person) {
        form.append('person', values.person)
      }
      if (values.notes) {
        form.append('notes', values.notes)
      }
    }

    submitQa(form, {
      onSuccess: (data) => {
        bag.setSubmitting(false)
        onCancel()
      },
      onError: (error, variables, context) => {
        bag.setSubmitting(false)
        if (error.response.status === 400) {
          const data = error.response?.data
          if (isNotValid(data)) {
            bag.setErrors(translateSymfonyErrorToFormik(data?.errors?.children))
          }
        }
      }
    })
  }

  const _initialForm = () => {
    if (qa) {
      return {
        lqa_type: qa.lqa_type,
        score: qa.score,
        date: qa.date,
        vendors: qa.vendor_id ? [qa.vendor_id] : [],
      }
    } else {
      return {
        lqa_type: 'Internal',
        score: '',
        date: Moment(),
        vendors: []
      }
    }
  }

  const initialValues = _initialForm()

  return (
    <ModalForm
      title={editing ? `QA / ${qa.vendor_name}` : 'QA'}
      initialValues={initialValues}
      onCancel={onCancel}
      validationSchema={ValidationSchema}
      onSubmit={handleSubmit}
      visible
      width={700}
      render={({ isSubmitting, setFieldValue, touched, errors, values }) => (
        <>
          <Form.Item label='Date' name='date' hasFeedback showValidateSuccess>
            <DatePicker name='date' format='YYYY-MM-DD' placeholder='Date' />
          </Form.Item>

          <Form.Item label='Type' name='lqa_type' hasFeedback showValidateSuccess required>
            <Select placeholder='Type' name='lqa_type'>
              {['Internal', 'Client', 'External'].map((e) => (
                <Select.Option value={e} key={e}>
                  {e}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          {!editing && (
            <Form.Item label='Vendor' name='vendors' hasFeedback required>
              <Select
                placeholder='Vendor'
                name='vendors'
                mode='multiple'
                showSearch
                options={vendors}
                filterOption={_filter}
                allowClear
              />
            </Form.Item>
          )}

          <Form.Item label='Score' name='score' hasFeedback showValidateSuccess required>
            <Input name='score' placeholder='Score' />
          </Form.Item>

          {!editing && (
            <>
              <Form.Item label='Scorecard' name='file'>
                <input
                  name='file'
                  type='file'
                  onChange={(event) => {
                    setFieldValue('file', event.currentTarget.files[0])
                  }}
                  className='form-control'
                />
              </Form.Item>

              <Form.Item label='Person' name='person'>
                <Input name='person' placeholder='Person' />
              </Form.Item>
              <Form.Item label='Notes' name='notes'>
                <Input.TextArea name='notes' placeholder='Notes' />
              </Form.Item>
            </>
          )}
        </>
      )}
    />
  )
}

/*
const Formulario2 = (props) => {
  const editing = props.lqa?.id > 0
  const _initialForm = () => {
    const { lqa } = props

    if (lqa) {
      return {
        lqa_type: lqa.lqa_type,
        score: lqa.score,
        date: lqa.date,
        vendors: lqa.vendor_id ? [lqa.vendor_id] : [],
      }
    } else {
      return {
        lqa_type: 'Internal',
        score: '',
        date: Moment(),
        vendors: [],
      }
    }
  }

  return (
    <ModalForm
      loading={props.loading}
      title={editing ? `LQA / ${props.lqa.vendor_name}` : 'LQA'}
      initialValues={_initialForm()}
      onCancel={props.handleCancel}
      validationSchema={ValidationSchema}
      onSubmit={props.handleSubmit}
      visible={props.visible}
      width={700}
      render={({ isSubmitting, setFieldValue, touched, errors, values }) => (
        <>
          <Form.Item label='Date' name='date' hasFeedback showValidateSuccess>
            <DatePicker name='date' format='YYYY-MM-DD' placeholder='Date' />
          </Form.Item>

          <Form.Item label='Type' name='lqa_type' hasFeedback showValidateSuccess required>
            <Select placeholder='Type' name='lqa_type'>
              {['Internal', 'Client', 'External'].map((e) => (
                <Select.Option value={e} key={e}>
                  {e}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          {!editing && (
            <Form.Item label='Vendor' name='vendors' hasFeedback required>
              <Select
                placeholder='Vendor'
                name='vendors'
                mode='multiple'
                showSearch
                options={props.vendors}
                filterOption={_filter}
                allowClear
              />
            </Form.Item>
          )}

          <Form.Item label='Score' name='score' hasFeedback showValidateSuccess required>
            <Input name='score' placeholder='Score' />
          </Form.Item>

          {!editing && (
            <>
              <Form.Item label='Scorecard' name='file'>
                <input
                  name='file'
                  type='file'
                  onChange={(event) => {
                    setFieldValue('file', event.currentTarget.files[0])
                  }}
                  className='form-control'
                />
              </Form.Item>

              <Form.Item label='Person' name='person'>
                <Input name='person' placeholder='Person' />
              </Form.Item>
              <Form.Item label='Notes' name='notes'>
                <Input.TextArea name='notes' placeholder='Notes' />
              </Form.Item>
            </>
          )}
        </>
      )}
    />
  )
}*/

export default Formulario
